__turbopack_context__.v({
  "loadingScrim": "gallery-viewer-module-scss-module__qYV9ba__loadingScrim",
  "map": "gallery-viewer-module-scss-module__qYV9ba__map",
  "svgWrapper": "gallery-viewer-module-scss-module__qYV9ba__svgWrapper",
  "wrapper": "gallery-viewer-module-scss-module__qYV9ba__wrapper",
});
